var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "site-header" }, [
    _c(
      "h1",
      {
        class: {
          hidden: _vm.overridenVisible ? !_vm.overridenVisible : !_vm.visible
        }
      },
      [_vm._v(_vm._s(_vm.title))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }